import styled from "styled-components";

export const PageContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 32px 40px 48px;
  @media (max-width: 1024px) {
    padding: 24px 20px 40px;
  }
  @media (max-width: 640px) {
    padding: 20px 12px 32px;
  }
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: #64748b;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: #e8521a;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const HeaderLeft = styled.div``;

export const PageTitle = styled.h1`
  margin: 0 0 4px;
  color: #111;
  font-family: "Syne", sans-serif;
  font-size: 24px;
  font-weight: 800;
`;

export const PageSubtitle = styled.p`
  margin: 0;
  color: #9ca3af;
  font-family: Inter, sans-serif;
  font-size: 13px;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ActionButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;

  &:hover {
    border-color: #d1d5db;
    background: #f9fafb;
  }

  &.primary {
    background: #e8521a;
    border-color: #e8521a;
    color: #fff;
    &:hover {
      background: #d14a17;
    }
  }

  &.danger {
    color: #dc2626;
    border-color: #fecaca;
    &:hover {
      background: #fef2f2;
    }
  }

  &.outline {
    color: #1d4ed8;
    border-color: #bfdbfe;
    &:hover {
      background: #eff6ff;
    }
  }
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 600;
  background: ${({ $bg }) => $bg || "#f3f4f6"};
  color: ${({ $color }) => $color || "#374151"};
`;

export const StatusDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ $dot }) => $dot || "#9ca3af"};
`;

export const MarketplaceBadge = styled.span`
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  background: #eff6ff;
  color: #1d4ed8;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
`;

export const Card = styled.section`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 16px;
`;

export const CardTitle = styled.h2`
  margin: 0 0 16px;
  color: #111;
  font-family: "Syne", sans-serif;
  font-size: 15px;
  font-weight: 700;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoItem = styled.div``;

export const InfoLabel = styled.div`
  color: #9ca3af;
  font-family: Inter, sans-serif;
  font-size: 12px;
  margin-bottom: 4px;
`;

export const InfoValue = styled.div`
  color: #111;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
`;

export const ProductTable = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
`;

export const ProductRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
`;

export const ProductThumb = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 8px;
  background: ${({ $img }) => ($img ? `url(${$img}) center/cover` : "#f3f4f6")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
`;

export const ProductInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ProductName = styled.div`
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #111;
  margin-bottom: 2px;
`;

export const ProductMeta = styled.div`
  font-family: Inter, sans-serif;
  font-size: 12px;
  color: #9ca3af;
`;

export const ProductPrice = styled.div`
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
`;

export const SummarySection = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-family: Inter, sans-serif;
  font-size: 14px;
  color: #6b7280;
`;

export const GrandTotal = styled(SummaryRow)`
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  font-size: 16px;
  font-weight: 700;
  color: #111;
`;

export const AddressText = styled.p`
  margin: 0;
  color: #374151;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 1.6;
`;

export const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const InvoiceBox = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
`;

export const InvoiceRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-family: Inter, sans-serif;
  font-size: 13px;
  color: #6b7280;
`;

export const ErrorState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #9ca3af;
  font-family: Inter, sans-serif;
`;

export const TrackLink = styled.a`
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
